import React, { Fragment } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Table, TableBody, TableRow, TableCell, TableContainer, TableHead, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(2) },
  tableContainer: {
    border: '1px solid #70707047',
    marginBottom: theme.spacing(2)
  },
  tableHeader: { backgroundColor: '#E3E3E3' },
  tableRow: {
    borderTop: '1px solid #70707047',
    '& td': {
      fontSize: 14,
      color: theme.palette.primary.lightBlack
    }
  },
  tableCell: {
    padding: theme.spacing(1),
    border: 'none'
  },
  title: {
    fontSize: 20,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1)
  },
  description: {
    fontSize: 14,
    color: theme.palette.primary.lightBlack,
    marginBottom: theme.spacing(1)
  },
  header: { backgroundColor: '#E3E3E3' },
  tableHeading: { fontWeight: 'bold' },
  err: { '& td': { color: 'red' } },
  note: {
    backgroundColor: '#bcbcbc40',
    color: theme.palette.primary.lightBlack,
    fontSize: 14,
    padding: theme.spacing(1)
  }
}));

export function LRCTooltip({ tierName, plans }) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Pricing Calculation </Typography>
      <Typography className={classes.description}>
        Labor Reimbursement Coverage will be extended by a period of 3 years (from default 2 years to 5 years) or 8
        years (from default 2 to 10 years) in addition to the default 2-year coverage from the date of installation.
        Refer below table for further clarification:
      </Typography>
      <TableContainer className={classes.tableContainer}>
        <Table aria-label="sticky table">
          <TableHead className={classes.header}>
            <TableRow tabIndex={-1}>
              <TableCell className={clsx(classes.tableCell, classes.tableHeading)}>Extension Period (Years)​</TableCell>
              <TableCell className={clsx(classes.tableCell, classes.tableHeading)} colSpan={2}>
                ($) Price Per Inverter *
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* <TableRow className={classes.tableRow} tabIndex={-1}>
              <TableCell className={classes.tableCell} />
              <TableCell className={classes.tableCell}>Within 90 Days of Installation</TableCell>
              <TableCell className={classes.tableCell}>After 90 Days of Installation</TableCell>
            </TableRow> */}
            {plans &&
              plans.map(plan => (
                <TableRow className={classes.tableRow} tabIndex={-1} key={plan.id}>
                  <TableCell className={classes.tableCell}>{`${plan.extension} Years`}</TableCell>
                  {[ 'price_90d' ].map(label => (
                    <TableCell className={classes.tableCell} key={label}>
                      {plan.discount_percentage ? (
                        <Fragment>
                          <del>{`$${plan.price[label]}`}</del>&nbsp;
                          {`$${plan.price['discount_' + label].toFixed(2)}`}
                        </Fragment>
                      ) : (
                        plan.price[label]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            {!(plans && plans[0]) && (
              <TableRow className={clsx(classes.tableRow, classes.err)} tabIndex={-1}>
                <TableCell colSpan={3}>Could not find any plan Details</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {plans &&
      plans[0] &&
      plans[0].discount_percentage > 0 && (
        <Typography className={classes.note}>
          *Based on your{tierName ? ` ${tierName}` : ''} membership you are eligible for a{' '}
          {plans[0].discount_percentage}% discounted price.
        </Typography>
      )}
    </Box>
  );
}

export function PriceTooltip({ price, count, plans, sku }) {
  const classes = useStyles();
  const plan = plans.find(plan => plan.sku === sku);
  const originalPrice = plan.price.price_90d;
  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Price Calculation</Typography>
      <TableContainer className={classes.tableContainer}>
        <Table aria-label="sticky table">
          <TableHead className={classes.header}>
            <TableRow tabIndex={-1}>
              <TableCell className={classes.tableCell}>($) Price Per Inverter​</TableCell>
              <TableCell className={classes.tableCell}>Qty</TableCell>
              <TableCell className={classes.tableCell}>Total Cost</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={classes.tableRow} tabIndex={-1}>
              <TableCell className={classes.tableCell}>
                {plans[0].discount_percentage ? (
                  <Fragment>
                    <del>{`$${originalPrice}`}</del>&nbsp;
                    {`$${price.toFixed(2)}`}
                  </Fragment>
                ) : (
                  `$${originalPrice.toFixed(2)}`
                )}
              </TableCell>
              <TableCell className={classes.tableCell}>{count}</TableCell>
              <TableCell className={classes.tableCell}>${(price * count).toFixed(2)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
